// creates an array from 1 to 100
const data = Array.from(Array(100), (_, i) => {
    return { value: i + 1 };
});
export default data;
